import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import http from '../../Api/http';
import toast from "react-hot-toast";
import StatusBadge from "./StatusBadge";
import { useAuth } from '../AuthContext';
import { useTranslation } from "react-i18next";
import { Plus, PackageSearch, ArrowLeft, Calendar, FileText, RefreshCw, X, Home } from "lucide-react";
import Shipment from "./Shipment";
import Util from "../../Util";
import { Card } from "../card/Card";
import { Navigate } from "react-router-dom";

const Input = (props) => (
  <input {...props} className="border px-2 py-1 rounded-lg w-full border py-1 px-2 rounded focus:ring-2 focus:ring-blue-500 outline-none" />
);

const SupplierDashboard = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar" || i18n.language === "he";
  const navigate = useNavigate();

  const { user, loadingUser } = useAuth();
  const [shipmentId, setShipmentId] = useState(0);
  const [openShipmentDialog, setOpenShipmentDialog] = useState(false);
  const [openSuppliersDialog, setOpenSuppliersDialog] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [shipments, setShipments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [suppliers, setSuppliers] = useState([]);
  const [supplier, setSupplier] = useState(-1);
  const [dateFrom, setDateFrom] = useState(() => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    return Util.formatDateLocal(firstDay);

  });
  const [dateTo, setDateTo] = useState("");
  const [statusFilter, setStatusFilter] = useState(0);
  const StatusList = [
    { Id: 1, Name: t('new') },
    { Id: 2, Name: t('sent') },
    { Id: 3, Name: t('received') },
    { Id: 4, Name: t('mustReturn') },
    { Id: 5, Name: t('returnedToSupplier') },
    { Id: 6, Name: t('approved') },
  ]

  const drpSupplier = useRef();

  const handleReset = async () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    setDateFrom(Util.formatDateLocal(firstDay));
    setDateTo("");
    setStatusFilter(0);

    await loadShipments(0, firstDay, "");
  };

  const loadShipments = async (statusId, from = dateFrom, to = dateTo) => {
    try {
      setIsLoading(true);
      const obj = {
        StatusId: statusId || 0,
        UserId: user?.ID
      }
      if (from)
        obj.FromDate = from;
      if (to)
        obj.ToDate = to;
      const res = await http.postJsonAxios(http.actions.Shipments.GetShipments, obj, t);
      if (res.status === 200 && res.data.success) {
        setShipments(res.data.obj);
      }
    } catch { }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user?.ID) {
      loadShipments();
      loadSuppliers();
    }
  }, [user]);

  const loadSuppliers = async () => {
    const res = await http.getJsonAxios(http.actions.Shipments.GetSuppliers);
    if (res.status === 200 && res.data.success) {
      setSuppliers(res.data.dataObject);
    }
  };

  const onCreateShipment = async () => {
    if (user?.Role === 3) {
      CreateShipment();
    }
    else {
      setOpenSuppliersDialog(true);
    }
  }
  const saveCreateShipment = async () => {
    console.log(supplier)
    if (!supplier || supplier === '-1' || supplier === -1) {
      console.log('error')
      toast.error(t('selectSupplierError'), Util.getErrorToast());
      if (drpSupplier) drpSupplier.current.focus();
      return;
    }
    CreateShipment();
  }
  const CreateShipment = async () => {
    try {
      setIsLoading(true);
      setIsCreating(true);
      const obj = {
        UserId: user?.ID,
        SupplierId: user?.Role === 3 ? user?.ID : supplier
      }
      const res = await http.postJsonAxios(http.actions.Shipments.CreateShipment, obj, t);

      if (res.status === 200 && res.data.success) {
        toast.success(t('done'), Util.getSuccessToast());
        loadShipments(); // إعادة تحميل القائمة
        setShipmentId(res.data.Id);
        setSupplier(-1);
        setOpenSuppliersDialog(false);
        setOpenShipmentDialog(true);
      } else {
        toast.error(t('failed'));
      }
    } catch { }
    finally {
      setIsLoading(false);
      setIsCreating(false);
    }
  };


  if (loadingUser) return null;
  if (!user) return <Navigate to="/" />;

  return (
    <div className="p-4 md:p-6 space-y-6 max-w-7xl mx-auto" dir={t('dir')}>
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-16"
      >
        <h1 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900 dark:text-white items-center gap-2">
          <button
            onClick={() => navigate("/SpareParts")}
            className="hover:text-primary transition"
            title={t('myOrders')}
          >
            <Home className="w-9 h-9 text-blue-500 hover:text-blue-700" />
          </button>
          {t("myOrders")}
        </h1>
        <div className="h-1.5 w-24 bg-accent mx-auto rounded-full" />
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          {t('ordersSubTitle')}
        </p>
      </motion.div>

      {/* Filters */}
      <Card>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

          {/* Dates */}
          <Input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
          <Input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} />

          {/* Status */}
          <select value={statusFilter} onChange={e => {
            setStatusFilter(e.target.value);
          }}
            className="border px-2 py-1 rounded-lg w-full border py-1 px-2 rounded focus:ring-2 focus:ring-blue-500 outline-none" dir={t('dir')}>
            <option value="">{t('selectStatus')}</option>
            {StatusList.map(status => (
              <option key={status.Id} value={status.Id}>
                {status.Name}
              </option>
            ))}
          </select>

        </div>

        <div className="flex flex-col sm:flex-row gap-3 p-4 border-t">

          {/* Create */}
          <button
            onClick={onCreateShipment}
            disabled={isCreating}
            className="w-full sm:w-auto flex items-center justify-center gap-2 h-10 px-4 rounded
               bg-green-600 text-white hover:bg-green-700
               shadow-lg shadow-green-600/25 transition"
          >
            <Plus size={18} />
            {isCreating ? t("creating") : t("newOrder")}
          </button>

          {/* Refresh */}
          <button
            onClick={loadShipments}
            className="w-full sm:w-auto flex items-center justify-center gap-2 h-10 px-4 rounded
               bg-blue-500 text-white hover:bg-blue-700
               shadow-lg shadow-blue-600/25 transition"
          >
            <RefreshCw size={18} />
            {t("refresh")}
          </button>

          {/* Reset */}
          <button
            onClick={handleReset}
            className="w-full sm:w-auto flex items-center justify-center gap-2 h-10 px-4 rounded
               bg-orange-500 text-white hover:bg-orange-700
               shadow-lg shadow-orange-600/25 transition"
          >
            <X size={18} />
            {t("resetFilters")}
          </button>

        </div>
        {/* Shipment Dialog */}
        {
          openShipmentDialog &&
          <Shipment
            open={openShipmentDialog}
            onClose={() => {
              setOpenShipmentDialog(false);
              setIsCreating(false);
              loadShipments();
            }}
            shipmentId={shipmentId}  // 0 تعني شحنة جديدة
          />
        }
        {
          openSuppliersDialog &&
          <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center px-4 sm:px-6" dir={t('dir')}>

            <div className="bg-white dark:bg-gray-800 p-4 sm:p-6 rounded-2xl w-full max-w-md relative flex flex-col gap-4">

              {/* Close Button */}
              <button
                className={isRTL ? "absolute top-4 left-4 text-xl" : "absolute top-4 right-4 text-xl"}
                onClick={() => setOpenSuppliersDialog(false)}
              >
                ✖️
              </button>

              {/* Title */}
              <h3 className="text-lg font-bold">{t('newOrder')}</h3>

              {/* Input */}
              <div className="flex flex-col gap-2 w-full">
                <label className="text-sm font-medium">{t('theSupplier')}</label>
                {/* Supplier */}
                <select ref={drpSupplier} disabled={user?.Role === 3} value={supplier} onChange={e => { console.log(e.target.value); setSupplier(e.target.value); }}
                  className="border px-2 py-1 rounded-lg w-full border py-1 px-2 rounded focus:ring-2 focus:ring-blue-500 outline-none" dir={t('dir')}>
                  <option key={-1} value={-1}>{t('selectSupplier')}</option>
                  {suppliers.map(s => (
                    <option key={s.ID} value={s.ID}>{s.Name}</option>
                  ))}
                </select>
              </div>

              {/* Action Button */}
              <button
                className="w-full bg-green-600 text-white px-4 py-2 rounded-md flex justify-center items-center gap-2
                                    hover:bg-green-700 shadow-lg shadow-green-600/25 transition"
                onClick={() => saveCreateShipment()}
              >
                {t('save')}
              </button>
            </div>
          </div>
        }
      </Card >

      {/* Loading */}
      {isLoading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="h-44 rounded-xl bg-gray-200 animate-pulse"
            />
          ))}

        </div>
      )}

      {/* Empty State */}

      {!isLoading && shipments.length === 0 && (

        <div className="border-2 border-dashed rounded-xl p-16 text-center flex flex-col items-center">

          <PackageSearch size={60} className="text-gray-400 mb-4" />

          <h3 className="text-xl font-bold mb-2">
            {t('noOrders')}
          </h3>

          <p className="text-gray-500 mb-6">
            {t('creatingSubTitle')}
          </p>

          <button
            onClick={() => onCreateShipment()}
            className="px-6 py-3 border rounded-lg hover:bg-gray-50"
          >
            {t('createOrder')}
          </button>

        </div>
      )}

      {/* Shipments List */}

      {!isLoading && shipments.length > 0 && (

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" dir={t('dir')}>
          {shipments.map((shipment, index) => (

            <motion.div
              key={shipment.Id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05 }}
            >
              <div onClick={() => {
                setShipmentId(shipment.Id);
                setOpenShipmentDialog(true);
              }}>
                <div className="border rounded-xl p-5 hover:shadow-lg transition cursor-pointer h-full flex flex-col">
                  {/* Header */}
                  <div className="flex justify-between mb-4">
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded text-sm font-bold">
                      #{shipment.Id}
                    </span>
                    <StatusBadge status={shipment.StatusId} />
                  </div>
                  {/* Info */}
                  <div className="space-y-2 text-sm text-gray-500 flex-1">
                    <div className="flex items-center gap-2">
                      <Calendar size={16} />
                      {new Date(shipment.InsDate).toLocaleDateString()}
                    </div>
                    <div className="flex items-center gap-2">
                      <FileText size={16} />
                      {shipment.ItemsCount || 0} {t('spareParts')}
                    </div>
                    {shipment.Notes && (
                      <p className="bg-gray-50 p-2 rounded text-gray-700 line-clamp-2">
                        {shipment.Notes}
                      </p>
                    )}
                  </div>
                  {/* Footer */}
                  <div className="flex justify-between items-center mt-4 pt-4 border-t text-primary font-semibold text-sm">
                    <span>{t('showDetails')}</span>
                    <ArrowLeft size={16} />
                  </div>
                </div>
              </div>

            </motion.div>

          ))}

        </div>
      )}

    </div>
  );
};

export default SupplierDashboard;